
<ng-template [ngIf]="isUpdatingOda">
      <app-loading></app-loading>
</ng-template>
    <div class="d-flex mt-2">
            <form [formGroup]="modificaOdaForm">
                <div class="grid formgrid p-fluid">
                   <!-- <div class="field mt-2 mb-2 col-3">
                        <label for="bando" class="font-medium text-900 text-blue-900">BANDO</label>
                        <span class="p-input-icon-left" >
                          
                            <p-dropdown inputId="bando" [options]="bandi" optionLabel="denominazione" [showClear]="true"
                                placeholder="Scegli il bando" formControlName="bando"
                                (onChange)="onBandoSelection($event)">
                                <ng-template let-bando pTemplate="item">
                                    <p-tag
                                        [value]="bando.denominazione | uppercase"
                                        [style]="{
                                            'background-color': bando.denominazione==='BANDO 1'?'cadetblue':'cornflowerblue' ,
                                            'color': '#ffffff' ,
                                            'border-radius': '6px',
                                            'padding': '.25em .5rem',
                                            'font-weight': '700',
                                            'font-size': '13px',
                                            'letter-spacing': '.3px;',
                                            'cursor': 'pointer',
                                        }"
                                    ></p-tag>
                                </ng-template>
                            </p-dropdown>
                        </span>
                    </div> -->
                    <!-- <div class="field mt-2 mb-2 col-3">
                        <label for="lotti" class="font-medium text-900 text-blue-900">LOTTI</label>
                        <span class="p-input-icon-left" >
                            <p-multiSelect 
                            inputId="lotti" 
                            [options]="lotti" 
                            [showClear]="true"
                            [filter]="false"
                            [selectedItemsLabel]="'TUTTI'" 
                            placeholder="Scegli i lotti" 
                            formControlName="lotti">
                            <ng-template let-lotto pTemplate="item">
                                <div class="flex align-items-center">
                                    <div>{{lotto | uppercase}}</div>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                        </span>
                    </div> -->
                    <div class="field mt-2 mb-2 col-3">
                        <label for="numero" class="font-medium text-900 text-blue-600">NUMERO</label>
                        <p-inputNumber inputId="numero" formControlName="numero" [styleClass]="'right-align'" [useGrouping]="false"
                        (onBlur)="checkNumero($event)"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-3">
                        <label for="importo" class="font-medium text-900 text-green-600">IMPORTO</label>
                        <p-inputNumber mode="currency" maxFractionDigits="2"
                            inputId="importo" 
                            currency="EUR" locale="it-IT" 
                            formControlName="importo" 
                            [styleClass]="'right-align'"> 
                        </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-6">
                        <label for="referenteTim" class="font-medium text-900 text-gray-600">REFERENTE TIM</label>
                        <input type="text" pInputText formControlName="referenteTim" />
                    </div>
                </div> 
            </form>
     </div>




<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
<div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isUpdatingOda || !modificaOdaForm.valid"></p-button>
</div>
<p-toast />
